import {Modal as BootstrapModal, ModalFooter, ModalBody, ModalHeader} from 'reactstrap'
import {toastr} from 'react-redux-toastr'

import Loader from '../../../../shared/components/Loader/Loader.jsx'
import Modal from '../../../../shared/components//Modals/Modal.jsx'

import api from '../../../../api.js'

export default class DeleteMissionModal extends Modal {
  constructor(props) {
    super(props)
    this.state = { loading: false }
  }

  delete = async () => {
    let experiences = this.props?.experiences?.length ? this.props.experiences : []
    experiences = experiences.filter(exp => exp.id !== this.props.experienceId)

    try {
      await api.freelances.experiences.delete({
        freelance: this.props.freelance.id,
        experience: this.props.experienceId
      })
    } finally {
      this.setState({ loading: false })

      if(this.props.onClose) {
        this.props.onClose(experiences)
      }

      this.props.closeModal()
      toastr.success('La mission a été supprimée avec succès.')
    }
  }

  render() {
    if (!this.props.freelance) {
      return null
    }

    const experience = (this.props.offset !== undefined && this.props.freelance.experiences[this.props.offset]) || null

    return (
      <BootstrapModal toggle={this.props.closeModal} isOpen={this.props.isOpen} className="mission-modal modal-lg">
        <ModalHeader toggle={this.props.closeModal}>Suppression</ModalHeader>
        <ModalBody>
          <div className="text-center">
            Vous êtes sur le point de supprimer votre expérience
            {experience && experience.title && <b>&nbsp;{experience.title}</b>}.
            Cette action est irreversible.
          </div>
          <Loader visible={this.state.loading}>
            Suppression...
          </Loader>
        </ModalBody>
        <ModalFooter>
          <button onClick={this.props.closeModal} type="button" className="btn btn-outline-shy">Annuler</button>
          <button onClick={this.delete} type="button" className="ml-auto btn btn-danger">Supprimer</button>
        </ModalFooter>
      </BootstrapModal>
    )
  }
}
